import { useNavigate } from 'react-router-dom';
import Button from '@/components/atoms/Button/Button';
import AiSearchComposer from '@/Pages/Sessions/RecentEvents/AiClips/AiSearchComposer';

export default function HomeHeader() {
  const navigate = useNavigate();

  const handleManageBrandKit = () => {
    navigate('/brand-kit');
  };

  return (
    <div className="pr-4">
      <div className="mb-8 flex items-center justify-between">
        <div className="text-3xl font-medium text-slate-950">Content Lab</div>
        <Button variation="outline" trackingId="brand-kit-button" buttonSize="small" onClick={handleManageBrandKit}>
          Manage Brand Kit
        </Button>
      </div>
      <AiSearchComposer />
    </div>
  );
}
